<div class="sidenav-item">
  <div class="sidenav-item-link" matRipple>
    <mat-checkbox (change)="toggleCheckbox()" [checked]="isChecked()" [indeterminate]="isIndeterminate()"
                  [style.--checkbox-checked-color]="parent?.color ?? item.color">
      <span class="name">{{ item.name }}</span>
    </mat-checkbox>
    <span class="badge">{{ item.reports_count }}</span>
    <mat-icon class="icon expand-indicator" *ngIf="item.sub_categories?.length" (click)="togglePanel(item)">
      <ng-container *ngIf="!dropdownOpen.includes(item.id)">keyboard_arrow_down</ng-container>
      <ng-container *ngIf="dropdownOpen.includes(item.id)">keyboard_arrow_up</ng-container>
    </mat-icon>
  </div>

  <mat-expansion-panel *ngIf="item.sub_categories" class="dropdown mat-elevation-z0" hideToggle [expanded]="dropdownOpen.includes(item.id)">
    <fury-sidenav-item *ngFor="let subItem of item.sub_categories" [item]="subItem" [parent]="item"></fury-sidenav-item>
  </mat-expansion-panel>
</div>
